/* src/app/help-desk/presenters/help-desk.component.scss */
body#themeTag :host ::ng-deep .sticky-table-container .p-datatable {
  max-height: calc(100vh - 230px);
}
body#themeTag :host ::ng-deep .sticky-table-container .p-datatable .p-datatable-thead > tr:nth-child(2) > th {
  top: 25px;
}
/*# sourceMappingURL=help-desk.component.css.map */
